import { formatDate } from 'features/order-tracker/utils/dateUtils';
import {
  AUTH_STATUS_LOGGED_IN,
  AUTH_STATUS_NOT_LOGGED_IN,
} from './constants';

export class PageLoadAnalyticsService {
  private componentRef: React.RefObject<HTMLElement | null> | null = null;

  trackPageLoad = (pageName: string, isAuthenticated: boolean): void => {
    const timestamp = formatDate('YYYY/MM/DD HH:mm:ss');
    const analyticsEvent = new CustomEvent('pageLoaded', {
      detail: {
        pageName: `BTB:BYA:Track your order:${pageName}`,
        loggedInStatus: isAuthenticated ? AUTH_STATUS_LOGGED_IN : AUTH_STATUS_NOT_LOGGED_IN,
        timestamp,
      },
    });

    this.componentRef?.current?.dispatchEvent(analyticsEvent);
  };

  setComponentRef = (componentRef: React.RefObject<HTMLElement | null>): void => {
    this.componentRef = componentRef;
  };
}

export const pageLoadAnalyticsService = new PageLoadAnalyticsService();
